export default __webpack_public_path__ + "static/index-teachers-5babb4c934cd521197706fdfdf4026c9.png";